import { render, staticRenderFns } from "./M_role.vue?vue&type=template&id=5382df22&scoped=true&"
import script from "./M_role.vue?vue&type=script&lang=js&"
export * from "./M_role.vue?vue&type=script&lang=js&"
import style0 from "./M_role.vue?vue&type=style&index=0&id=5382df22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5382df22",
  null
  
)

export default component.exports